import {svgInfoTwLogoUnder15, svgInfoTwLogoForAll} from '../SvgCode'
import {ITwInfoData} from "../../interface/IFooter";

import DataStore from "../DataStore";

export default class infoTW{
    private ds : DataStore

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        const infoData = this.getInfoData(this.ds.service);

        this.templ(_wrapper, infoData);
    }

    templ(_parent: HTMLElement, infoData: ITwInfoData){

        _parent.classList.add('footer-info-tw');
        _parent.innerHTML= `
        <div class="info-inner">
            <span class="info-img">${infoData.logo}</span>
            <p class="info-text"> ${infoData.text} </p>
        </div>
        `;
    }

    getInfoData(_service: string){
        let data: ITwInfoData = {
            text: '',
            logo: svgInfoTwLogoUnder15,
        };

        if(_service === 'puzzup'){
            data.text = `
                本遊戲軟體為普遍級，任何年齡皆得使用<br>
                本遊戲為免費使用，遊戲內部分虛擬物品或服務需另行支付其他費用<br>
                請注意遊戲時間，避免沉迷，遊戲虛擬情節勿模仿
            `;
            data.logo = svgInfoTwLogoForAll;
        }else{
            data.text = `
                本遊戲情節涉及角色穿著表達輕微性暗示、暴力、恐怖。<br>
                本遊戲部分內容或服務需另行支付其他費用，應避免過度消費。<br>
                注意使用時間，避免沉迷於遊戲，可能影響身心健康。
            `;
            data.logo = svgInfoTwLogoUnder15;
        }

        return data;
    }
}
